import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { LoaderService } from '../../shared/loader/loader.service';
import { GlobalService } from '../../shared/services/global.service';
import { SharedModule } from '../../shared/shared.module';
import { LoginService } from '../../core/services/login.service';
import { ModalService } from '../../shared/modals/modal.service';

@Component({
  selector: 'vs-select-business-unit',
  imports: [SharedModule],
  templateUrl: './select-business-unit.html',
  styleUrl: './select-business-unit.scss',
  encapsulation: ViewEncapsulation.None
})
export class SelectBusinessUnit implements OnInit{
  businessUnits: any[] = [];
  selectedBusinessUnitId!: string;
  constructor(private loader: LoaderService, private globalService: GlobalService,
     private loginService: LoginService, private modalService: ModalService){}
  ngOnInit(): void {
    sessionStorage.removeItem('lookup_data_fetched_in_session')
    this.businessUnits = this.globalService.getDataFromStorage('business-units');
    if(this.businessUnits.length) {
      this.businessUnits = this.businessUnits.sort((a,b) => a.BusinessUnitName.localeCompare(b.BusinessUnitName))
      this.selectedBusinessUnitId = this.businessUnits[0].BusinessUnitId
    }
    this.loader.setLoadingState.set(false);
    if(localStorage.getItem('selected-business-unit')) {
      this.loader.setLoadingState.set(true);
      this.loginService.fetchAndCacheLookupData().subscribe(res => {
        this.loginService.getUserDetails().subscribe(res => {
          this.loginService.storeUserDetails(res.Result);
          this.globalService.navigateToHomeByView();
        })
      });
    }
  }

  continue() {
    const fetchData = () => {
      this.loader.setLoadingState.set(true);
      this.loginService.fetchAndCacheLookupData().subscribe(res => {
        this.loginService.getUserDetails().subscribe(res => {
          this.loginService.storeUserDetails(res.Result);
          this.globalService.navigateToHomeByView();
        })
      });
    }  
    if(localStorage.getItem('selected-business-unit')) {
      const dialog = this.modalService
      .openCustomWarningDialog({
        message: 'bu.m',
        icon: 'i-alert-n',
        btnTxt2: 'cmn.ok',
        showIcon: true,
        showCheckBox: false,
        checkBoxMsg: '',
      })
      .subscribe(() => {
        dialog.unsubscribe();
        fetchData();
      });
    } else {
      localStorage.setItem('selected-business-unit', this.selectedBusinessUnitId);
      fetchData();
    }      
  }
}
